<script setup lang="ts">
/**
 * PAGE CAGNOTTE — « Suivre l'association » : ses réseaux sociaux et son site, tels
 * que saisis dans sa fiche (mêmes liens que la page association).
 */
import { normalizeExternalUrl } from "~/utils/externalUrl";
import type { AssociationCagnotte } from "./types";

const props = defineProps<{
  liens: AssociationCagnotte["social_links"];
  site?: string | null;
  /** Centré sous le bloc association, ou ligne « libellé … icônes ». */
  centre?: boolean;
}>();

const { t } = useI18n();

const reseaux = computed(() => {
  const s = props.liens ?? {};
  return [
    { cle: "instagram", icone: "i-lucide-instagram", url: normalizeExternalUrl(s.instagram), nom: "Instagram" },
    { cle: "facebook", icone: "i-lucide-facebook", url: normalizeExternalUrl(s.facebook), nom: "Facebook" },
    { cle: "linkedin", icone: "i-lucide-linkedin", url: normalizeExternalUrl(s.linkedin), nom: "LinkedIn" },
    { cle: "youtube", icone: "i-lucide-youtube", url: normalizeExternalUrl(s.youtube), nom: "YouTube" },
    { cle: "twitter", icone: "i-lucide-twitter", url: normalizeExternalUrl(s.twitter), nom: "X" },
    { cle: "tiktok", icone: "i-simple-icons-tiktok", url: normalizeExternalUrl(s.tiktok), nom: "TikTok" },
    { cle: "site", icone: "i-lucide-link", url: normalizeExternalUrl(props.site ?? undefined), nom: t("campagne.pageCagnotte.siteWeb") },
  ].filter((r) => !!r.url);
});
</script>

<template>
  <div
    v-if="reseaux.length"
    class="flex items-center gap-4"
    :class="centre ? 'flex-col' : 'justify-between'"
  >
    <p class="text-[15px] text-gray-500 whitespace-nowrap">{{ $t("campagne.pageCagnotte.suivreAsso") }}</p>
    <div class="flex items-center">
      <a
        v-for="r in reseaux"
        :key="r.cle"
        :href="r.url ?? undefined"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="r.nom"
        :title="r.nom"
        class="w-9 h-9 rounded-full flex items-center justify-center text-(--color-ink) hover:bg-[#eef2ff] hover:text-(--color-main2) transition-colors"
      >
        <UIcon :name="r.icone" class="size-5" />
      </a>
    </div>
  </div>
</template>
